import _ from "lodash"
import { JsonPlaceholderReplacer } from "json-placeholder-replacer"

const dataSelector = ({objectData, template,instanceData,scannerInstanceData,path}) => {

  try {

  // Get the value in our object that matches our path
  const valueOrReference = _.cloneDeep(_.get(objectData ?? template,path))

  // This could be a fixed value or a reference to something in our instance data, or a combination / multiple references
  // This next call will resolve any references that are present.
  const placeHolderReplacer = new JsonPlaceholderReplacer()
  placeHolderReplacer.addVariableMap(instanceData)
  if (scannerInstanceData) placeHolderReplacer.addVariableMap({__scanner_data__:scannerInstanceData})

  // We have to pass in an object, not a string, so we use "item"
  const result = placeHolderReplacer.replace({item:valueOrReference})

  // Now we have a value with all references resolved
  return result.item
  }
  catch(err) {
    throw err
  }
}

export default dataSelector